export default "__VITE_ASSET__368f9a40__"